import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeroComponent} from './hero.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {LimitedTextModule} from '../../../shared/limited-text/limited-text.module';
import {CtaFormModule} from '../../cta-form/cta-form.module';
import {NgbCarouselModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {ProductDetailsSectionModule} from '../product-details-section/product-details-section.module';
import {ProductNameDisplayModule} from '../navigation-bar/product-name-display/product-name-display.module';
import {DcpMediaModule} from '../../../shared/dcp-media/dcp-media.module';
import {MediaModule, StarRatingModule} from '@spartacus/storefront';
import {ClassificationsTemplateModule} from '../classifications-template/classifications-template.module';
import {ReviewModule} from '../review/review.module';
import {HeroReviewComponent} from './hero-review/hero-review.component';

@NgModule({
  declarations: [
    HeroComponent,
    HeroReviewComponent
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductHeroComponent: {
          component: HeroComponent
        }
      }
    }),
    I18nModule,
    LimitedTextModule,
    CtaFormModule,
    NgbCarouselModule,
    NgbTooltipModule,
    ProductDetailsSectionModule,
    ProductNameDisplayModule,
    DcpMediaModule,
    MediaModule,
    ClassificationsTemplateModule,
    StarRatingModule,
    ReviewModule,
  ],
  exports: [
    HeroComponent
  ]
})
export class HeroModule {
}
